import React from 'react';
import ChapterItem from './ChapterItem';
import { TocElement } from '../../types/TocElement';

interface ChapterListProps {
    chapters: TocElement[];
    offset: number;
}

const ChapterList: React.FC<ChapterListProps> = ({ chapters, offset }) => {
    return (
        <div className="mt-4">
            {chapters.map(
                (chapter, index) =>
                    chapter.name && (
                        <div key={index}>
                            <ChapterItem chapter={chapter} offset={offset} />
                            {index !== chapters.length - 1 && (
                                <hr className="border-gray-400  border-1 opacity-50 border-dashed" />
                            )}
                        </div>
                    )
            )}
        </div>
    );
};

export default ChapterList;
